import { Controller } from "stimulus"
import { replaceElementWithResponse } from "../helpers"

export default class extends Controller {
  replaceWithResponse(event) {
    replaceElementWithResponse(this.element, event.detail.response)
  }
}
